import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Grid, Row, Panel, Accordion } from 'react-bootstrap';
import { TextBox } from 'devextreme-react';
import { Button } from 'devextreme-react';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import "./data.css";
import Box, { Item } from 'devextreme-react/box';
import notify from 'devextreme/ui/notify';
import DataGrid, {
    Column, ColumnChooser, ColumnFixing, Sorting, Scrolling, Format, FilterRow, Paging, Selection,
    HeaderFilter,
    FilterPanel
} from 'devextreme-react/data-grid';
import { Popup } from 'devextreme-react/popup';

export default class Data extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            enablePortfolioControl: true,
            updateAllPortfolioInfo: '',
            enableCurrencyControl: true,
            updateCurrencyInfo: '',
            updateButtonText: 'Обновить',
            updateCurrencyButtonText: 'Обновить'            
        };

        this.updateAllPortfolio = this.updateAllPortfolio.bind(this);
        this.onRefreshAllButtonClick = this.onRefreshAllButtonClick.bind(this);
        this.onUpdateCurrencyClick = this.onUpdateCurrencyClick.bind(this);
    }    

    updateAllPortfolio() {
        var tokenKey = "accessToken";

        this.setState({ enablePortfolioControl: false, updateButtonText: 'Обновление' });

        var token = sessionStorage.getItem(tokenKey);

        fetch('../api/main/updateAllPortfolio', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': 'Bearer ' + token
                }
            }).then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                this.setState({ enablePortfolioControl: true, updateButtonText: 'Обновить', updateAllPortfolioInfo: data.message });
                this.refreshData();
            });
    }

    onRefreshAllButtonClick() {
        this.updateAllPortfolio();
    }

    onUpdateCurrencyClick(e) {
        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        var currencyData = {
            dateFrom: null,
            dateTo: null
        }

        this.setState({ enableCurrencyControl: false, updateCurrencyButtonText: 'Обновление' });

        fetch('api/main/UpdateCurrency', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify(currencyData)
            })
            .then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                this.setState({ enableCurrencyControl: true, updateCurrencyButtonText: 'Обновить', updateCurrencyInfo: data.message });
                this.refreshData();
            });
    }

    render() {


        return (
            <Grid fluid className="positionGrid">
                <Row>
                    <Col lg={12}>
                        <div className="helpBlock">
                            <span className="helpIcon dx-icon-tips"></span>
                            <div className="helpText">
                                Выполнение операций на этой странице может занимать продолжительное время (в зависимости от количества активных клиентов и отображаемых портфелей).
                            </div>
                        </div>
                        </Col>
                </Row>
                <Row>
                    <Col lg={8}>
                        <Box className="detailLine"
                             direction={'row'}
                             width={'70%'}
                             height={'auto'}>
                            <Item
                                ratio={1}>
                                <div className="testClass">
                                    <div className="verticalContent"><span className="dx-icon-clock"></span> Обновить ВСЕ данные до T-2 </div>
                                </div>
                            </Item>                              
                            <Item
                                ratio={0}
                                baseSize={220}>
                                <div className="testClass">
                                    <div className="verticalContent">
                                    <Button className="toolboxButton" id="button"
                                            
                                        type={'default'}
                                            disabled={!this.state.enablePortfolioControl}
                                            stylingMode={'contained'}
                                            width={200}
                                            height={36}
                                            onClick={this.onRefreshAllButtonClick}
                                    >
                                        <LoadIndicator className="button-indicator" visible={!this.state.enablePortfolioControl} />
                                        <span className="dx-button-text">{this.state.updateButtonText}</span>
                                        </Button>
                                        </div>
                                </div>
                            </Item>
                            <Item
                                ratio={1}>
                                <div className="testClass">
                                    <div className="verticalContent">{this.state.updateAllPortfolioInfo}</div>
                                </div>
                            </Item>
                        </Box>
                    </Col>
                </Row>                   
                <Row>
                    <Col lg={8}>
                        <Box className="detailLine"
                             direction={'row'}
                             width={'70%'}
                             height={'auto'}>
                            <Item
                                ratio={1}>
                                <div className="testClass">
                                    <div className="verticalContent"><span className="dx-icon-clock"></span> Обновить курсы валют </div>
                                </div>
                            </Item>                            
                            <Item
                                ratio={0}
                                baseSize={220}>
                                <div className="centerContent">
                                    <Button className="toolboxButton" id="currencyButton"                                          
                                        type={'default'}
                                            disabled={!this.state.enableCurrencyControl}
                                            stylingMode={'contained'}
                                        width={200}
                                        height={36}
                                        onClick={this.onUpdateCurrencyClick}
                                    >
                                        <LoadIndicator className="button-indicator" visible={!this.state.enableCurrencyControl} />
                                        <span className="dx-button-text">{this.state.updateCurrencyButtonText}</span>
                                        </Button>
                                </div>
                            </Item>
                            <Item
                                ratio={1}>
                                <div className="testClass">
                                    <div className="verticalContent">{this.state.updateCurrencyInfo}</div>
                                </div>
                            </Item>
                        </Box>
                    </Col>
                </Row>          
            </Grid>
        );

    }
}


// WEBPACK FOOTER //
// ./App/containers/data/data.jsx